import { useEffect, useState } from "react";

// Loads `res.data` rows for `body`; refetches when the body's content changes and ignores
// responses from an older body. `skip` keeps it idle (e.g. until an accordion row is opened).
export default function useApiRows(fetch, body, skip = false) {
    const [rows, setRows] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const key = JSON.stringify(body);

    useEffect(() => {
        if (skip) return;

        let cancelled = false;
        setIsLoading(true);
        setRows([]);

        fetch(JSON.parse(key))
            .then((res) => {
                if (!cancelled) setRows(res?.data || []);
            })
            .catch(() => {
                if (!cancelled) setRows([]);
            })
            .finally(() => {
                if (!cancelled) setIsLoading(false);
            });

        return () => {
            cancelled = true;
        };
    }, [fetch, key, skip]);

    return [rows, isLoading];
}
